import { Button, PopoverContent, PopoverTrigger, Popover } from '@readcloud/ui';
import { ComponentProps, useState } from 'react';

/**
 * A Button which, on click, shows a popover requiring the user to click on either a confirm or back button if `confirmationRequired` is true.
 */
export function ConfirmationPopoverButton(
  props: ComponentProps<typeof Button> & {
    confirmationRequired: boolean;
    onConfirm: () => void;
    prompt: React.ReactChild;
    confirmButtonText: React.ReactChild;
    backButtonText: React.ReactChild;
    children: React.ReactChild;
  }
) {
  const [show, setShow] = useState(false);
  const {
    confirmationRequired,
    onConfirm,
    prompt,
    confirmButtonText,
    backButtonText,
    ...buttonProps
  } = props;
  return (
    <Popover
      open={show}
      onOpenChange={(nextShow) => {
        if (nextShow && !confirmationRequired) {
          onConfirm();
        } else {
          setShow(nextShow);
        }
      }}
    >
      <PopoverTrigger asChild>
        <Button {...buttonProps} />
      </PopoverTrigger>
      <PopoverContent className="rc-bg-background rc-rounded rc-z-[2100]">
        <div className="rc-flex rc-flex-col rc-gap-2">
          <p>{props.prompt}</p>
          <div
            style={{
              display: 'flex',
              gap: '0.5rem',
              justifyContent: 'flex-end',
            }}
          >
            <Button size="sm" onClick={() => setShow(false)} variant="ghost">
              {props.backButtonText}
            </Button>
            <Button
              data-testid="confirmationPopoverConfirmButton"
              size="sm"
              onClick={() => {
                setShow(false);
                props.onConfirm();
              }}
              variant="destructive"
            >
              {props.confirmButtonText}
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
